var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfToPptx = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 161,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9213_1775)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.833 5.32308C142.132 3.94268 161.518 -3.41956 179.807 1.91346C199.063 7.52856 213.456 21.0381 224.973 35.1068C237.051 49.86 251.263 66.8263 247.333 84.3986C243.373 102.109 252.849 117.68 238.895 131.412C227.707 142.423 188.655 150.848 173.216 157.341C157.945 163.763 139.845 160.065 122.833 158.673C107.206 157.395 92.2834 154.685 77.8404 149.537C61.8904 143.852 46.5478 137.385 34.3056 127.121C19.5871 114.781 -1.99131 101.732 0.147587 84.3986C2.34911 66.5579 30.9027 60.5172 44.2568 46.4786C55.1526 35.0243 56.3879 17.4502 71.2232 9.67995C86.1291 1.87278 105.306 6.57666 122.833 5.32308Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 119.52V42.4796C32.5 40.2686 34.2382 38.5 36.3538 38.5H81.2713L99.4476 57.2014V119.52C99.4476 121.731 97.7094 123.5 95.5938 123.5H36.3538C34.2391 123.5 32.5 121.732 32.5 119.52Z",
    fill: "white",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4937,
    y: 95.5,
    width: 50.9602,
    height: 21,
    rx: 2.18571,
    fill: "#D2294B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4937,
    y: 95.5,
    width: 50.9602,
    height: 21,
    rx: 2.18571,
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8882 110.476V101.524H57.9536C58.9468 101.524 59.7128 101.778 60.2515 102.286C60.7902 102.785 61.0595 103.484 61.0595 104.381C61.0595 105.278 60.7902 105.981 60.2515 106.489C59.7128 106.997 58.9468 107.251 57.9536 107.251H55.8452V110.476H53.8882ZM55.8452 105.727H57.6254C58.6607 105.727 59.1783 105.278 59.1783 104.381C59.1783 103.501 58.6607 103.06 57.6254 103.06H55.8452V105.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2724 110.476V101.524H65.757C67.2721 101.524 68.4463 101.913 69.2796 102.692C70.1129 103.463 70.5295 104.563 70.5295 105.994C70.5295 107.424 70.1129 108.529 69.2796 109.308C68.4463 110.087 67.2721 110.476 65.757 110.476H62.2724ZM64.2293 108.864H65.6434C67.5373 108.864 68.4842 107.907 68.4842 105.994C68.4842 104.089 67.5373 103.137 65.6434 103.137H64.2293V108.864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0498 110.476V101.524H78.0596V103.06H74.0068V105.245H77.7818V106.781H74.0068V110.476H72.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2065 52.5996V39.236L98.8209 56.411H85.8772C83.8658 56.411 82.2065 54.7209 82.2065 52.5996Z",
    fill: "white",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 63.5H84C84.8284 63.5 85.5 64.1716 85.5 65V66C85.5 66.8284 84.8284 67.5 84 67.5H48C47.1716 67.5 46.5 66.8284 46.5 66V65C46.5 64.1716 47.1716 63.5 48 63.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 73.5H84C84.8284 73.5 85.5 74.1716 85.5 75V76C85.5 76.8284 84.8284 77.5 84 77.5H48C47.1716 77.5 46.5 76.8284 46.5 76V75C46.5 74.1716 47.1716 73.5 48 73.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 83.5H84C84.8284 83.5 85.5 84.1716 85.5 85V86C85.5 86.8284 84.8284 87.5 84 87.5H48C47.1716 87.5 46.5 86.8284 46.5 86V85C46.5 84.1716 47.1716 83.5 48 83.5Z",
    fill: "#D2294B",
    stroke: "#D2294B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.692 70.7745L133.538 76.0574C135.846 78.1436 137 79.1867 137 80.5305C137 81.8742 135.846 82.9173 133.538 85.0035L127.692 90.2865C126.639 91.2387 126.112 91.7149 125.678 91.5166C125.243 91.3182 125.243 90.6016 125.243 89.1682V85.6603C119.946 85.6603 114.207 88.2252 112 92.5C112 78.8205 119.848 75.4007 125.243 75.4007V71.8927C125.243 70.4594 125.243 69.7427 125.678 69.5444C126.112 69.3461 126.639 69.8222 127.692 70.7745Z",
    fill: "#1D1D1D",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5 119.52V42.4796C149.5 40.2689 151.239 38.5 153.357 38.5H198.309L216.5 57.2015V119.52C216.5 121.731 214.76 123.5 212.643 123.5H153.357C151.24 123.5 149.5 121.732 149.5 119.52Z",
    fill: "white",
    stroke: "#E25F49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 94.5,
    width: 51,
    height: 21,
    rx: 2.18571,
    fill: "#E25F49"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.5,
    y: 94.5,
    width: 51,
    height: 21,
    rx: 2.18571,
    stroke: "#E25F49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.084 109V100.54H171.948C172.58 100.54 173.116 100.648 173.556 100.864C173.996 101.08 174.328 101.388 174.552 101.788C174.784 102.188 174.9 102.672 174.9 103.24C174.9 103.808 174.784 104.296 174.552 104.704C174.328 105.104 173.996 105.412 173.556 105.628C173.116 105.844 172.58 105.952 171.948 105.952H169.944V109H168.084ZM169.944 104.512H171.636C172.116 104.512 172.48 104.404 172.728 104.188C172.984 103.972 173.112 103.656 173.112 103.24C173.112 102.824 172.984 102.512 172.728 102.304C172.48 102.096 172.116 101.992 171.636 101.992H169.944V104.512ZM176.053 109V100.54H179.917C180.549 100.54 181.085 100.648 181.525 100.864C181.965 101.08 182.297 101.388 182.521 101.788C182.753 102.188 182.869 102.672 182.869 103.24C182.869 103.808 182.753 104.296 182.521 104.704C182.297 105.104 181.965 105.412 181.525 105.628C181.085 105.844 180.549 105.952 179.917 105.952H177.913V109H176.053ZM177.913 104.512H179.605C180.085 104.512 180.449 104.404 180.697 104.188C180.953 103.972 181.081 103.656 181.081 103.24C181.081 102.824 180.953 102.512 180.697 102.304C180.449 102.096 180.085 101.992 179.605 101.992H177.913V104.512ZM185.839 109V102.076H183.043V100.54H190.495V102.076H187.699V109H185.839ZM190.373 109L193.913 104.296V105.124L190.469 100.54H192.629L194.969 103.768H194.369L196.697 100.54H198.869L195.413 105.124V104.296L198.953 109H196.781L194.357 105.652H194.969L192.557 109H190.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.192 52.5996V39.2353L215.82 56.411H202.866C200.853 56.411 199.192 54.7205 199.192 52.5996Z",
    fill: "white",
    stroke: "#E25F49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 57.1249L170 83.5653C170 84.1864 170.504 84.6899 171.125 84.6899L175.658 84.6899C176.279 84.6899 176.783 84.1864 176.783 83.5653L176.783 57.1249C176.783 56.5038 176.279 56.0003 175.658 56.0003L171.125 56.0003C170.504 56.0003 170 56.5038 170 57.1249Z",
    fill: "#E25F49",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.562 88L195.438 88C195.748 88 196 87.7482 196 87.4377L196 86.3554C196 86.0449 195.748 85.7931 195.438 85.7931L170.562 85.7931C170.252 85.7931 170 86.0449 170 86.3554L170 87.4377C170 87.7482 170.252 88 170.562 88Z",
    fill: "#E25F49",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.608 63.1939L179.608 83.5653C179.608 84.1864 180.112 84.6899 180.733 84.6899L185.266 84.6899C185.887 84.6899 186.391 84.1864 186.391 83.5653L186.391 63.1939C186.391 62.5728 185.887 62.0693 185.266 62.0693L180.733 62.0693C180.112 62.0693 179.608 62.5728 179.608 63.1939Z",
    fill: "#E25F49",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.218 70.3663L189.218 83.5653C189.218 84.1864 189.721 84.6899 190.342 84.6899L194.876 84.6899C195.497 84.6899 196 84.1864 196 83.5653L196 70.3663C196 69.7452 195.497 69.2417 194.876 69.2417L190.342 69.2417C189.721 69.2417 189.218 69.7452 189.218 70.3663Z",
    fill: "#E25F49",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9213_1775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 161,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfToPptx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf_to_pptx.f9508428c51900b6c373b774840ecb0e.svg";